import {getSheet} from "../sheets";
import {findIndex, find} from "../helpers/array";
import {validationConditions} from "../helpers/conditional";
import {setSpanCss} from "./spans";
import {getType} from "./types";
import group from "./undo_group";

export function init(view){
	view.validation = {
		handlers: webix.copy(validationConditions),
		get: (row, column, page) => get(view, row, column, page),
		add: (row, column, rule, page) => add(view, row, column, rule, false, page),
		remove: (row, column, page) => remove(view, row, column, false, page),
		highlight: (state, page) => highlight(view, state, page),
		_pull:{}
	};

	view.attachEvent("onReset", () => reset(view));
	view.attachEvent("onUndo", (type, row, column, value) => {
		if (type === "validation")
			undo(view, row, column, value);
	});

	view.attachEvent("onAction", (action, p)=> {
		if(action == "before-grid-change")
			updatePosition(view, p.name, p.inc, p.data, p.start);
	});

	view.attachEvent("onCommand", action => {
		if(action.id == "highlight-invalid-data")
			view.validation.highlight(true);
		else if(action.id == "remove-highlight-invalid-data")
			view.validation.highlight();
		else if(action.id == "remove-cell-validation")
			group.set(()=> view.eachSelectedCell(cell => view.validation.remove(cell.row, cell.column)));
	});

	view.attachEvent("onDataSerialize", data => [data.validation, data.table.highlightInvalid] = serialize(view));
	view.attachEvent("onDataParse", data => parse(view, data));
	view.attachEvent("onReset", () => {
		view.validation._pull = {};
		view.validation._highlight = false;
	});
	view.attachEvent("onChange", ()=> showValidationPopup(view));
	view.$$("cells").attachEvent("onSelectChange", () => showValidationPopup(view));
}

function serialize(view){
	const pull = view.validation._pull;
	const data = [];
	for(let row in pull)
		for(let column in pull[row])
			data.push([row, column, pull[row][column]]);
	return [data, view.validation._highlight ? 1 : 0];
}

function parse(view, data){
	const validation = data.validation;
	if(validation)
		for(let i = 0; i < validation.length; i++){
			const item = validation[i];
			if(!view.validation._pull[item[0]])
				view.validation._pull[item[0]] = {};
			view.validation._pull[item[0]][item[1]] = item[2];
		}
	if(data.table && data.table.highlightInvalid)
		view.validation._highlight = true;
	
}

function get(view, row, column, page){
	let validation;
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet && sheet.content.validation){
			validation = find(sheet.content.validation, validation => validation[0] == row && validation[1] == column);
			if(validation)
				validation = validation[2];
		}
	}
	else if(view.validation._pull[row] && view.validation._pull[row][column])
		validation = view.validation._pull[row][column];
	return validation || null;
}

function add(view, row, column, validation, silent, page){
	page = page || view.getActiveSheet();
	const oldValue = get(view, row, column, page);

	if(page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(!sheet.content.validation)
			sheet.content.validation = [];

		if(oldValue)
			find(sheet.content.validation, validation => validation[0] == row && validation[1] == column)[2] = validation;
		else
			sheet.content.validation.push([row, column, validation]);
	}
	else{
		if(!view.validation._pull[row])
			view.validation._pull[row] = {};

		view.validation._pull[row][column] = validation;
	}

	if (!silent)
		view.callEvent("onAction", ["validation", {row, column, newValue:validation, value:oldValue, page}]);
}

function highlight(view, state, page){
	page = page || view.getActiveSheet();
	if(page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(!sheet.content.table)
			sheet.content.table = {};
		if(state == "toggle")
			state = !sheet.content.table.highlightInvalid;
		else
			state = !!state;
		sheet.content.table.highlightInvalid = state ? 1 : 0;
	}
	else{
		if(state == "toggle")
			view.validation._highlight = !view.validation._highlight;
		else
			view.validation._highlight = !!state;
		view.refresh();
	}
}

function remove(view, row, column, silent, page){
	page = page || view.getActiveSheet();

	const old = get(view, row, column, page);
	if(old){
		if(page != view.getActiveSheet()){
			const validation = getSheet(view, page).content.validation;
			const index = findIndex(validation, validation => validation[0] == row && validation[1] == column);
			validation.splice(index, 1);
		}
		else{
			delete view.validation._pull[row][column];
			view.$$("cells").updateItem(row, column);
		}
		if (!silent)
			view.callEvent("onAction", ["validation", {row, column, newValue: null, value: old, page}]);
	}
}

function updatePosition(view, name, inc, data, start){
	let validation = data.validation,
		i = validation.length;

	if(inc){
		while(i--){
			let [row,column] = validation[i];
			if(row && name == "row" && row >= start.row || column && name == "column" && column >= start.column){
				if (name == "row"){
					if (row < start.row - inc)	//delete rule if row was deleted
						validation.splice(i,1);
					else						//update position if upper row was deleted
						validation[i][0] = row*1 + inc;
				} else if (name == "column"){
					if (column < start.column - inc){
						validation.splice(i, 1);
					} else 
						validation[i][1] = column*1 + inc;
				}
			}
		}
	}
}

function undo(view, row, column, value){
	if(get(view, row, column))
		remove(view, row, column, true);
	if(value)
		add(view, row, column, value, true);
}

function reset(view){
	view.validation._pull = {};
}

function getCellValue(view, value){
	if(isNaN(value*1)){
		if (value.charAt(0) == "=" && value.length > 1){
			value = view._mData.getStore().exec(value.substring(1), view._mPage.getContext());
			if(value === null)
				value = "";
		}
	}
	else {
		value = value*1;
	}
	return value;
}

export function isInvalid(view, row, column, rendered, page){
	let invalid = false;
	const rule = view.validation.get(row, column, page);
	if(rule){
		const type = rule.type;

		let value;
		if(!webix.isUndefined(rendered) && (type == "text" || type == "textLength"))
			value = rendered;
		else
			value = view.getCellValue(row, column, false, page);

		if(value === "")
			return !!rule.ignoreEmpty;

		let compare = rule.value;
		if(compare){
			if(webix.isArray(compare))
				compare = {
					start: getCellValue(view, compare[0]),
					end: getCellValue(view, compare[1])
				};
			else
				compare = getCellValue(view, compare);
		}

		const handlers = view.validation.handlers[type];
		if(handlers){
			const handler = find(handlers, obj => obj.id == rule.condition).handler;
			if(!handler(value, compare)) invalid = true;
		}

		if(!invalid)
			switch(type){
				case "number":
					if(rule.integer && parseInt(value) != value)
						invalid = true;
					break;
				case "date":
					if(getType(view, row, column, page) != "date")
						invalid = true;
					break;
				case "range":
					if(!(webix.isArray(compare) && compare.indexOf(value) != -1))
						invalid = true;
					break;
			}
	}
	return invalid;
}

export function getValidationCss(view, row, column, rendered){
	let css = "";

	if(view.validation._highlight && isInvalid(view, row, column, rendered))
		css = "webix_ss_invalid_data";

	const span = view.$$("cells").getSpan(row, column);
	if(span)
		setSpanCss(view, row, column, "webix_ss_invalid_data", !!css);

	return css;
}

function showValidationPopup(view){
	if(view._commentSel)
		return;

	let sel = view.getSelectedId(true);
	let popup = view.validation._inputMessage;
	if(!view._context && sel && sel.length == 1){
		sel = sel[0];
		const row = sel.row;
		const col = sel.column;

		const validation = view.validation.get(row, col);
		if(validation && validation.inputMessage){
			if(!popup){
				popup = view.validation._inputMessage = webix.ui({
					view: "popup",
					css: "ssheet_validation_input_message",
					minWidth:150,
					minHeight:50,
					height:100,
					width:250,
					resize:true,
					body:{
						scroll:"auto",
						template: " "
					}
				});
				view._destroy_with_me.push(popup);
			}
			popup.getBody().setHTML(validation.inputMessage);

			const grid = view.$$("cells");
			const span = grid.getSpan(row, col);
			const item = span ? {row, column:(span[1]*1+span[2]-1)} : sel;

			return popup.show(grid.getItemNode(item), {pos: "bottom"});
		}
	}
	if(popup)
		popup.hide();
}

export function pasteValidation(view, extra, row, col, cutted){
	const validation = extra.validation;

	view.validation.add(row, col, validation);
	if (cutted === 1)
		view.validation.remove(extra.row, extra.col);
}